import { enumValue, isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ProductArea } from "@faire/web-api--source/faire/logging/ProductArea";
import { ISettingEntry } from "@faire/web-api--source/indigofair/settings/ISettingEntry";
import { notifyAfter } from "./notifyAfter";
export function setting(setting) {
    var serializeToPages = (Array.isArray(setting.client) ? setting.client : [
        setting.client
    ]).map(function(page) {
        return enumValue(ISettingEntry.SerializeToClient, page);
    }).filter(isNotUndefined);
    var _setting_testable, _enumValue;
    return {
        name: setting.name,
        defaultValue: setting.defaultValue,
        valueValidation: setting.valueValidation,
        entryType: setting.type,
        identifierType: setting.identifier,
        testable: (_setting_testable = setting.testable) !== null && _setting_testable !== void 0 ? _setting_testable : false,
        serializeToPages: serializeToPages,
        notifyAfter: notifyAfter(setting.notifyAfter),
        monitorClientPerformance: setting.monitorClientPerformance ? serializeToPages : [],
        productArea: (_enumValue = enumValue(ProductArea, setting.productArea)) !== null && _enumValue !== void 0 ? _enumValue : ProductArea.PRODUCT_AREA_UNKNOWN
    };
}
